import React from "react";
import { Door } from "./types";

interface DoorPanelProps {
  doors: Door[];
  handleAddDoor: () => void;
}

// Kolumny nagłówka to te same ścieżki siatki co w wierszach DoorTable.tsx
// (--door-cols w 1/style.css) - etykiety stoją nad polami bez ręcznych przesunięć.
const DoorPanel: React.FC<DoorPanelProps> = ({ doors, handleAddDoor }) => (
  <div className="doorPanel">
    <div className="doorPanel__name">
      <h1>Türbezeichnung</h1>
      <div className="buttonB" onClick={handleAddDoor} role="button" title="Tür hinzufügen" aria-label="Tür hinzufügen">
        <img
          src={"/img/configurator/plus.svg"}
          alt="plus"
          style={{ width: "20px", height: "20px", margin: "auto" }}
        />
      </div>
    </div>
    <p className="doorPanel__amount">Stück</p>
    <p className="doorPanel__type">Zylindertyp</p>
    <div className="doorPanel__length">
      <p>Länge in mm</p>
      <div className="doorPanel__sides">
        <p>außen</p>
        <p>innen</p>
      </div>
    </div>
  </div>
);

export default DoorPanel;
